import { createContext } from 'react';

export type SignersCtx = {
  showDeleteSignerConfirmAlert: boolean;
  showDeleteSignerErrorAlert: boolean;
  shouldShowMaximumSignerAlert: boolean;
  showEditSignerAlert: boolean;
  showDeleteSignerAlert: boolean;
  deleteSignerError: string;
};

const SignersContext = createContext<SignersCtx>({
  showDeleteSignerConfirmAlert: false,
  showDeleteSignerErrorAlert: false,
  shouldShowMaximumSignerAlert: false,
  showEditSignerAlert: false,
  showDeleteSignerAlert: false,
  deleteSignerError: '',
});

export default SignersContext;
